<script lang="ts" setup>
import { computed, PropType, ref } from "vue";
import { TaskParametersTemplatesList } from "../components";
import { ParametersTemplateModel } from "../models";
import { TaskParameterModel, TaskParameterTypeEnum } from "@/components";
import { ArrowDownTrayIcon } from "tir-style-system/icons/outline";
import { TirPmButton, TirPmButtonSizeEnum, TirPmButtonVariantEnum } from "tir-components";
import { TirPmSearchInput } from "tir-pm-search-input";

/**Параметры */
const props = defineProps({
  /**Тип настройки */
  type: { type: Number as PropType<TaskParameterTypeEnum> },
  /**Список шаблонов */
  templates: { type: Array as PropType<ParametersTemplateModel[]> },
});
/**События */
const emit = defineEmits<{
  /**Старт режима для импорта параметров */
  import: [];
  /**Редактировать шаблон */
  editCompound: [template: ParametersTemplateModel];
  /**Выбрать шаблон */
  select: [template: TaskParameterModel[]];
  /**Удалить шаблон */
  remove: [template: ParametersTemplateModel];
  /**Редактирование шаблона */
  upsert: [template: ParametersTemplateModel];
}>();

/**Поисковой запрос */
const search = ref("");

/**Текст кнопки импорта */
const importButtonText = computed(() => {
  let label = "Импортировать ";

  switch (props.type) {
    case TaskParameterTypeEnum.Status:
      label += "статусы";
      break;
    case TaskParameterTypeEnum.Priority:
      label += "приоритеты";
      break;
    case TaskParameterTypeEnum.Tag:
      label += "теги";
      break;
    case TaskParameterTypeEnum.Type:
      label += "типы";
      break;
    case TaskParameterTypeEnum.Difficulty:
      label += "сложности";
      break;
  }

  return label;
});
/**Найденные шаблона */
const searchedTemplates = computed(() => {
  const request = search.value.toLocaleLowerCase();
  if (!request) return props.templates;

  return props.templates.filter(
    (template) =>
      template.Name.toLocaleLowerCase().includes(request) ||
      template.ParsedData.some((parameter) => parameter.Name.toLocaleLowerCase().includes(request)),
  );
});

/**Открыть список параметров для импортирования */
const importParameters = () => {
  setTimeout(() => emit("import"));
};
/**Выбор параметров шаблона */
const selectParameters = (template: ParametersTemplateModel) => {
  emit("select", template.ParsedData);
};
</script>
<template>
  <div class="templates-list-form">
    <div class="templates-list-form_controls">
      <TirPmSearchInput
        v-model="search"
        class="templates-list-form_controls_input"
        placeholder=""
        label="Поиск по шаблонам"
        :is-with-popup="false"
      />
      <TirPmButton
        :size="TirPmButtonSizeEnum.Small"
        :variant="TirPmButtonVariantEnum.LinkState"
        @click="importParameters"
      >
        <ArrowDownTrayIcon />
        {{ importButtonText }}
      </TirPmButton>
    </div>
    <TaskParametersTemplatesList
      :type="type"
      :templates="searchedTemplates"
      @editCompound="emit('editCompound', $event)"
      @select="selectParameters"
      @remove="emit('remove', $event)"
      @upsert="emit('upsert', $event)"
    />
  </div>
</template>
<style lang="scss">
.templates-list-form {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  &_controls {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    &_input {
      width: 31.25rem;
    }
    .button__sign-main {
      display: flex;
      align-items: center;
      gap: 0.375rem;
      svg {
        width: 1rem;
        height: 1rem;
      }
    }
  }
}
</style>
